import axios from "axios";
import env from "../variables/EndpointEnvironment";

const NewsAPI = (props) => {
  return axios.get(`${env.HOST}/news/${props.slug}`, {
    headers: {
      "Content-Language": localStorage.getItem('i18nextLng'),
    },
  });
};

export default NewsAPI;
